module.exports = __webpack_public_path__ + "static/og-image-agb-75f5dad7b29150df86fe4668c66c63d9.png";